export function ADDRESSES(communityId) {
  return '/v4/installer/address/?communityId=' + communityId;
}
export function COMMUNITY(communityId) {
  return '/v4/installer/community/?communityId=' + communityId;
}

export const REQUEST_PERMISSION = 'v4/permission/create/';
